import { Component, Input, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { JobDetailsPage } from '../job-details/job-details.component';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { JobService } from '../../../../../../../UI/src/app/shared/job/job.service';
import { JobApplyObject } from '../../../../../../../UI/src/app/shared/job/job-apply-object.dto';

@Component({
  selector: 'sts-job-data',
  templateUrl: 'job-data.component.html'
})
export class JobDataComponent implements OnInit {
  @Input() job: any;
  @Input() caller: 'default';
  titleLocation : string[];

  
  constructor(
    public navCtrl: NavController,
    private profileService: ProfileService,
    private jobService: JobService,
  ) { }

  ngOnInit() {
    this.titleLocation = this.jobService.setJobcity(this.job);
   
  }

  openJobDetails(jobData) {
    if (this.navCtrl.getActive().name === "JobDetailsPage") {
      return;
    }
    const jobApplyObject: JobApplyObject = new JobApplyObject();
    jobApplyObject.JobId = jobData.id;
    jobApplyObject.ApplicationId = jobData.applicationId;
    jobApplyObject.IsDrafted = jobData.isDrafted;
    this.jobService.setApplyJobObject(jobApplyObject);
    this.navCtrl.push(JobDetailsPage, {"jobData": jobData, "navigatedFrom": this.navCtrl.getActive().name, "jobId": jobData.id });
  }

  saveFavouriteJob() {
    this.profileService.saveFavoriteJob(this.job.id).subscribe(
      (response) => {
        this.job.isFavorite = !this.job.isFavorite;
      }, (error) => {
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/job-data/job-data.component.ts